import getSisoTableRequest from '@domain/model/request/siso/getSisoTableRequest';
import sortSisoTable from '@hooks/siso/sortSisoTable';

const useSortSisoTable = (filters, table) => {
    const queries = getSisoTableRequest({ ...filters, ...table });
    return sortSisoTable(queries);
};

export default useSortSisoTable;
